import React, { Component } from 'react'
import { withRouter, Link } from 'react-router'
import { connect } from 'react-redux'
import { handleGameClick, handleErrorCode, showErrorMessage, renderGame } from '../GamesPageNewLayout/gameUtils.jsx'
import SignIn from '../../header/SignIn.jsx'
import { FormattedMessage } from 'react-intl'
import { messages } from '../GamesPageNewLayout/messages.js'
import Loader from '../../../../shared/components/Loader.jsx'

class PopularGamesPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      games: [],
      isLoading: true,
      showSignIn: false,
      favoriteGames: this.getFavoriteGamesFromStorage() || [],
      page: 1,
      limit: 20,
      prevScrollPos: window.pageYOffset,
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.handleLoadMoreGames = this.handleLoadMoreGames.bind(this)
  }

  componentDidMount() {
    this.fetchPopularGames()
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const { prevScrollPos, isLoading } = this.state
    const currentScrollPos = window.pageYOffset
    const isScrollingDown = currentScrollPos > prevScrollPos

    this.setState({ prevScrollPos: currentScrollPos })

    if (
      isScrollingDown &&
      window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100 &&
      !isLoading
    ) {
      this.handleLoadMoreGames()
    }
  }

  handleLoadMoreGames = () => {
    const { games, totalGames, isLoading } = this.state

    if (games.length >= totalGames || isLoading) {
      return
    }
    this.setState(prevState => {
      const newPage = prevState.page + 1

      if (!this.state.isLoading) {
        this.fetchPopularGames(newPage, true)
      }

      return { page: newPage }
    })
  }

  fetchPopularGames = async (page = 1, append = false) => {
    const { limit, games } = this.state
    this.setState({ isLoading: true })

    try {
      const offset = (page - 1) * limit
      const response = await fetch(`/api/games/all-games?limit=${limit}&offset=${offset}&isTop=true`)
      const data = await response.json()

      const popularGames = data.Items

      this.setState(prevState => ({
        isLoading: false,
        games: append ? [...prevState.games, ...popularGames] : popularGames,
        totalGames: data.totalCount || prevState.totalGames,
      }))
    } catch (error) {
      console.error('Failed to fetch games by category:', error)
      this.setState({ isLoading: false })
    }
  }

  openAuthModal = () => {
    const { user } = this.props

    if (user) {
      alert('Игра не доступна')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })

    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, () => this.openAuthModal())
    )
  }

  saveFavoriteGamesToStorage = favoriteGames => {
    localStorage.setItem('favoriteGames', JSON.stringify(favoriteGames))
  }

  getFavoriteGamesFromStorage = () => {
    try {
      const favorites = localStorage.getItem('favoriteGames')
      return favorites ? JSON.parse(favorites) : []
    } catch (error) {
      console.error('Failed to parse favorite games from localStorage:', error)
      return []
    }
  }

  addGameToFavorites = gameId => {
    const { favoriteGames, games } = this.state
    let gameToAdd = games.find(game => game.Id === gameId)

    const updatedFavorites = [...favoriteGames, gameToAdd]
    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }

  removeGameFromFavorites = gameId => {
    const updatedFavorites = this.state.favoriteGames.filter(game => game.Id !== gameId)
    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }

  unpinGame = async gameId => {
    const user = this.props.user

    if (!user) {
      alert('Зарегистрируйтесь для того чтобы удалить из избранных')
      return
    }

    const gamblerId = user.get('gamblerId')

    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы удалить из избранных')
      return
    }

    try {
      const response = await fetch(`/api/games/un-pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.removeGameFromFavorites(gameId)
      } else {
        console.error('Failed to unpin the game')
      }
    } catch (error) {
      console.error('Error unpinning the game:', error)
    }
  }

  pinGame = async gameId => {
    const user = this.props.user

    if (!user) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    const gamblerId = user.get('gamblerId')

    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    try {
      const response = await fetch(`/api/games/pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.addGameToFavorites(gameId)
      } else {
        this.removeGameFromFavorites(gameId)
      }
    } catch (error) {
      console.error('Error pinning the game:', error)
    }
  }

  openAuthModal = () => {
    const { user } = this.props

    if (user) {
      alert('Игра не доступна')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })

    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, this.openAuthModal)
    )
  }

  render() {
    const { games, isLoading, showSignIn } = this.state

    return (
      <div className="game-types-page">
        {showSignIn && <SignIn />}
        {isLoading && <Loader />}
        <Link to="/games">
          <button className="view-all-button">
            <FormattedMessage {...messages.goBackToGames} />
          </button>
        </Link>
        <h1 className="page-title">
          <FormattedMessage {...messages.popular} />
        </h1>

        <div className="game-list">
          {games.length > 0 ? (
            games.map(game =>
              renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.pinGame, this.unpinGame)
            )
          ) : (
            <div>
              {/* {/* <Loader /> */}
              Игр нет 
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.get('user'),
})

export default withRouter(connect(mapStateToProps)(PopularGamesPage))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/PopularGamesPage/PopularGames.jsx